module.exports = __webpack_public_path__ + "img/arrow.e3184174.png";